import LessonsList from './LessonsList';

export default LessonsList;
